import React from "react";
import { Screen } from '~common/screen';
import { Styled } from './styled'
import { StyledScreen } from '~common/screen'
import Form from '~/components/form'

const SellMoreScreen = () => {
  return (
    <Screen
      title={<span><StyledScreen.GreenText>Продавайте</StyledScreen.GreenText> больше с onlinepbx</span>}
    >
      <Styled.FormContainer>
        <Form free text='Подключить' pageName='Главная' />
      </Styled.FormContainer>
    </Screen>
  )
}

export { SellMoreScreen }